var render, staticRenderFns
import script from "./NgDialog.vue?vue&type=script&lang=js&"
export * from "./NgDialog.vue?vue&type=script&lang=js&"
import style0 from "./NgDialog.vue?vue&type=style&index=0&id=2da52d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da52d48",
  null
  
)

export default component.exports